// Test IDs for tenant loading / routing states (the screens shown before the
// storefront itself can render). Keys camelCase, values kebab-case — see auth.js.

export const TENANT = {
	loading: 'tenant-loading',
	error: 'tenant-error',
	retryButton: 'tenant-retry-button',
	notFound: 'tenant-not-found',
	name: 'tenant-name',
	mark: 'tenant-mark',
	markInitials: 'tenant-mark-initials',
};

export const ROUTE = {
	notFound: 'route-not-found',
};
